import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { resetForm, getGroupById, modifyGroup, addGroup, updateGroup } from 'groups/actions';

import { getEditing } from 'groups/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { getCustomFieldsEmployees } from 'custom_fields_employees/actions';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { valueFromEvent, createRoute } from 'lib/util';

class GroupsFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { groupId } = this.props.match.params;
    const { company, subcompany } = this.props;
    this.props.reset();

    groupId && this.props.getById(groupId, this.props.company.id, this.props.subcompany.id);

    const limit = 1000;
    const page = 1;
    const orderBy = '';
    const order = '';
    this.props.getCustoms(company.id, subcompany.id, '', limit, page);
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.group.id
          ? this.props.update(
              this.props.group.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.group
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.group);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'groups')
            );
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleCustomCheck = (e) => {
    let customCambio = e.target;
    //console.log(customCambio);

    // this.props.modify(payload);
    if (customCambio.checked)
      this.props.modify({
        custom: [
          ...this.props.group.custom,
          { _id: customCambio.value, nombre: customCambio.name },
        ],
      });
    else {
      let customsRemove = this.props.group.custom;
      let customsNew = [];
      customsRemove.forEach((custom) => {
        if (customCambio.value != custom._id) customsNew.push(custom);
      });
      this.props.modify({ custom: customsNew });
    }
  };
  //handleValueChange = e => this.props.modify(valueFromEvent(e));

  handleValueChange = (e) => {
    console.log(e);
    let payload = valueFromEvent(e);
    // payload = Object.keys(payload).reduce((re, k) => {
    //   if (k.indexOf("amount") > -1 ) {
    //     re[k] = parseFloat(payload[k]);
    //     re[k] = re[k] || "";
    //   } else {
    //     re[k] = payload[k];
    //   }
    //   return re;
    // }, {});

    this.props.modify(payload);
  };

  handleValidation = (isValid) => this.setState({ isValid });

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleCustomCheck: this.handleCustomCheck,
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  group: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addGroup,
  error: addGrowlError,
  getById: getGroupById,
  getCustoms: getCustomFieldsEmployees,
  modify: modifyGroup,
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateGroup,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupsFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/containers/GroupFormHandlers.js